export enum EditBoxAdjustment {
  DefaultBottomCheck = 55,
  BooleanBottomCheck = 22.5,
  BooleanWidthDivisor = 3,
  ReferenceBottomCheckTree = 325,
  ReferenceBottomCheck = 255,
  EditBoxRightPadding = 10
}
